import type { NavigateFunction } from 'react-router-dom'
import groups from './advancedGroups.json'

/** One Advanced item (advancedGroups.json). */
export interface AdvancedItem {
  id: string
  icon: string
  title: string
  line: string
  route?: string
  sub?: string
  tab?: string
  permission?: string
  aliases?: string[]
}

export interface AdvancedGroup {
  id: string
  title: string
  items: AdvancedItem[]
}

export const ADVANCED_GROUPS = (groups.groups as AdvancedGroup[])

export function advancedItem(id: string): AdvancedItem | undefined {
  for (const g of ADVANCED_GROUPS) {
    const it = g.items.find((i) => i.id === id)
    if (it) return it
  }
  return undefined
}

/** Old workbench tab id → its Advanced sub-route (the `aliases` in the data). */
export function advancedSubForAlias(tab: string): string | undefined {
  for (const g of ADVANCED_GROUPS) {
    for (const it of g.items) {
      if (it.sub && (it.aliases || []).includes(tab)) return it.sub
    }
  }
  return undefined
}

export function advancedItemForSub(sub: string): AdvancedItem | undefined {
  for (const g of ADVANCED_GROUPS) {
    const it = g.items.find((i) => i.sub === sub)
    if (it) return it
  }
  return undefined
}

export function openAdvancedItem(
  item: AdvancedItem, project: string, navigate: NavigateFunction,
  run: (action: string) => unknown,
): void {
  if (item.route) {
    navigate(item.route.replace('{project}', encodeURIComponent(project)))
  } else if (item.sub) {
    void run(`tab:advanced/${item.sub}`)
  } else if (item.tab) {
    void run(`tab:${item.tab}`)
  }
}
